export const isEmptyArray = (value: unknown): value is [] =>
  Array.isArray(value) && value.length === 0;
